<ion-skeleton-text animated *ngIf="loading" class="button-loader"></ion-skeleton-text>
<div id="paypal-button-container" [class.invisible]="loading" *ngIf="try <= maxRetries"></div>
